import {
  GET_PROMOTIONS,
  GET_PROMOTION,
  UPDATE_PROMOTION,
  CREATE_PROMOTION,
  DELETE_PROMOTION,
  GET_PROMOTIONS_REQUEST_PENDING,
  GET_PROMOTIONS_REQUEST_SUCCESS,
  GET_PROMOTIONS_REQUEST_ERROR,
  CHANGE_PROMOTIONS_REQUEST_PENDING,
  CHANGE_PROMOTIONS_REQUEST_SUCCESS,
  CHANGE_PROMOTIONS_REQUEST_ERROR,
} from '../types/promotions'

const initialState = {
  items: [],
  pagination: {
    current: 1,
    pageSize: 10,
  },
  item: {},
  isGetLoading: false,
  isChangeLoading: false,
  errors: [],
}

const promotions = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROMOTIONS:
      return { ...state, ...action.payload }
    case GET_PROMOTION:
      return { ...state, item: action.payload }
    case UPDATE_PROMOTION:
      const itemIndex = state.items.findIndex((item) => item.id === action.payload.id)
      const newItems = [...state.items]
      newItems[itemIndex] = { ...action.payload }
      return { ...state, items: newItems }
    case CREATE_PROMOTION:
      return { ...state, items: [...state.items, action.payload] }
    case DELETE_PROMOTION:
      return { ...state, items: state.items.filter((item) => item.id !== action.payload) }
    case GET_PROMOTIONS_REQUEST_PENDING:
      return { ...state, isGetLoading: true }
    case GET_PROMOTIONS_REQUEST_SUCCESS:
      return { ...state, errors: [], isGetLoading: false }
    case GET_PROMOTIONS_REQUEST_ERROR:
      return { ...state, errors: action.payload, isGetLoading: false }
    case CHANGE_PROMOTIONS_REQUEST_PENDING:
      return { ...state, isChangeLoading: true }
    case CHANGE_PROMOTIONS_REQUEST_SUCCESS:
      return { ...state, errors: [], isChangeLoading: false }
    case CHANGE_PROMOTIONS_REQUEST_ERROR:
      return { ...state, errors: action.payload, isChangeLoading: false }
    default:
      return state
  }
}

export default promotions
